import type { MentionFilterCriteria } from "@/features/mentions/mention-filter-criteria";

/**
 * O link que abre a tela de menções JÁ FILTRADA (2026-11-02): `?filtro=`
 * com o recorte no formato do filtro salvo (`MentionFilterCriteria`), o
 * mesmo que a tela sabe restaurar. Quem linka hoje é o painel "Pontos de
 * atenção" da Visão Geral: "12 negativas no Tier 1" abre exatamente essas
 * 12, no mesmo período.
 *
 * A rota de menções aplica o recorte SUBSTITUINDO o filtro que a pessoa
 * tinha na empresa (como o "Ver menções" de um upload) e tira o
 * parâmetro da URL, pra um F5 não reaplicar por cima do que ela mexeu
 * depois.
 */
export const MENTION_FILTER_PARAM = "filtro";

export function mentionFilterSearch(criteria: MentionFilterCriteria): string {
  return `?${new URLSearchParams({ [MENTION_FILTER_PARAM]: JSON.stringify(criteria) })}`;
}

/** O recorte do link, ou `null` quando o parâmetro falta ou não é um
 *  recorte (link colado pela metade, editado à mão): a tela abre com o
 *  filtro que já tinha, em vez de quebrar. */
export function criteriaFromSearch(params: URLSearchParams): MentionFilterCriteria | null {
  const raw = params.get(MENTION_FILTER_PARAM);
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
    if (typeof (parsed as { schema_version?: unknown }).schema_version !== "number") return null;
    return parsed as MentionFilterCriteria;
  } catch {
    return null;
  }
}
